import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=64e53d64"
import script from "./BaseAlert.vue?vue&type=script&lang=ts"
export * from "./BaseAlert.vue?vue&type=script&lang=ts"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=64e53d64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports